import { Injectable } from '@angular/core';
import { EllosApiService } from 'src/app/core/http/ellosApi.service';
import { EllosApi } from 'src/app/core/interfaces/ellosApi.interface';
import EllosRequest from 'src/app/core/interfaces/ellosRequest.interface';
import { UserConsensus } from '../interfaces/user-consensus';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserConsensusService {
  constructor(private readonly ellosApi: EllosApiService) {}

  async getUserConsentInfo(email: string, platform: number, version: number): Promise<UserConsensus> {
    const request: EllosRequest = {
      ellosApi: EllosApi.Associate,
      resource: `UserConsent/consentCookie?email=${email}&platform=${platform}&version=${version}`,
      body: null
    };

    try {
      const response = await this.ellosApi.get<UserConsensus>(request);
      return response.data;
    } catch (e) {
      throw e;
    }
  }

  sendConsent(email: string, platform: number, version: number): Observable<any> {
    const request: EllosRequest = {
      ellosApi: EllosApi.Associate,
      resource: `UserConsent/consentCookie?email=${email}&platform=${platform}&version=${version}`,
      body: null
    };
    return from(this.ellosApi.get<any>(request));
  }

  async createUserConsent(input: UserConsensus): Promise<any> {
    const request: EllosRequest = {
      ellosApi: EllosApi.Associate,
      resource: `UserConsent/consentCookieCreate`,
      body: input
    };

    try {
      const response = await this.ellosApi.post<UserConsensus>(request);
      return response.data;
    } catch (e) {
      throw e;
    }
  }
}
